import { call, takeEvery } from 'redux-saga/effects';
import { sendEmailRequest } from '../../requests/send_email_request';
import { message_error, message_success } from '../../../../../components/Message';

function* sendEmail({ template_id, lead_id }) {
    const sendEmailReq = yield call(sendEmailRequest, template_id, lead_id);
    const { result, error } = sendEmailReq;

    result ? message_success('Email sent successfully!') : message_error(error.message);
}

export default function* sendEmailSaga() {
    yield takeEvery('SEND_EMAIL_REQUEST', sendEmail);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/send_email.saga.js